import type { Study } from '@pocketprep/types'
import { runCloudFunction } from '@/store/ParseUtils'
import { fetchLibLoadable } from '@/loadingUtils'
import { licenseModule } from '@/store/license/module'
import { organizationModule } from '@/store/organization/module'

const fetchCurrentOrgLicenses = async (forceFetch?: boolean) => {
    const currentOrganization = await organizationModule.actions.fetchCurrentOrganization()

    if (!currentOrganization) {
        throw new Error('fetchCurrentOrgLicenses: Could not find currentOrganization')
    }

    return fetchLibLoadable(licenseModule, 'currentOrgLicenses', currentOrganization.objectId, async () => {
        type TFetchOrgLicenses = (params: { organizationId: string }) => Promise<Study.Class.LicenseJSON[]>
        return runCloudFunction<TFetchOrgLicenses>(
            'fetchOrgLicenses',
            { organizationId: currentOrganization.objectId }
        )
    }, forceFetch)
}

export default { fetchCurrentOrgLicenses }
